"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Share = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
var Share = function (_a) {
    var voucher = _a.voucher;
    var copyValue = voucher.type === 'promo-code' ? voucher.hash : process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/videos/" + voucher.video_id + "?voucher=" + voucher.hash;
    var ButtonCopy = storybook_1.Hooks.useCopy(copyValue)[0];
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ButtonCopy, null));
};
exports.Share = Share;
exports.Share.propTypes = {
    voucher: prop_types_1.default.object.isRequired
};
